import React, { useEffect } from 'react';
import { useAppDispatch } from '../../hooks/redux';
import { getSamlSession, loginAction } from '../../redux/actions/authActions';
import { LoginActionResponse } from '../../redux/actions/authActions/types';

export default function SamlLogin() {
    const dispatch = useAppDispatch();
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get('saml_session');

    const loginWithSaml = async () => {
        const ssoLoginPath = '/login?sso-login=true';
        try {
            const samlResult = await dispatch(getSamlSession({ sessionId: sessionId! }));
            console.log('SAML Result:', samlResult);

            if (!samlResult.payload) {
                document.location.href = ssoLoginPath;
                return;
            }

            const { email, token } = samlResult.payload as { email: string; token: string };

            const data = { userName: email, ssoToken: token };

            const loginResult = (await dispatch(
                loginAction({ ...data, userName: data.userName!.trim(), ssoToken: data.ssoToken }),
            )) as LoginActionResponse;

            if (loginResult.payload?.user) {
                document.location.href = '/dashboard';
            } else {
                document.location.href = ssoLoginPath;
            }
        } catch (error) {
            console.log('Error:', error);
            document.location.href = ssoLoginPath;
        }
    };

    useEffect(() => {
        loginWithSaml();
    }, []);

    return <></>;
}
